import React from 'react'
import './index.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faGraduationCap,
  faClock,
} from '@fortawesome/free-solid-svg-icons'
import BreadCrumb from '../../BreadCrumb'

/**
 * Courses Component for Student Dashboard
 * Displays enrolled and available courses for the student
 */
const Courses = () => {
  // Sample courses data (would come from API in production)
  const enrolledCourses = []
  const availableCourses = [
    {
      id: 1,
      title: 'Introduction to Mathematics',
      instructor: 'Dr. Jane Smith',
      duration: '8 weeks',
      progress: 0,
      image:
        'https://images.unsplash.com/photo-1509228468518-180dd4864904?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80',
    },
    {
      id: 2,
      title: 'Physics Fundamentals',
      instructor: 'Prof. Michael Brown',
      duration: '10 weeks',
      progress: 0,
      image:
        'https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80',
    },
  ]

  return (
    <div className="courses p-4 md:p-6">
      <BreadCrumb
        title="My Courses"
        slugs={[
          { display: 'Dashboard', to: '/dashboard', active: false },
          { display: 'Courses', to: '/dashboard/courses', active: true },
        ]}
      />

      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-bold mb-4">Enrolled Courses</h2>
        {enrolledCourses.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {enrolledCourses.map((course) => (
              <CourseCard key={course.id} course={course} enrolled={true} />
            ))}
          </div>
        ) : (
          <div className="bg-gray-50 rounded-lg p-6 text-center">
            <FontAwesomeIcon
              icon={faGraduationCap}
              className="text-3xl md:text-4xl text-gray-400 mb-3"
            />
            <h3 className="text-lg font-medium mb-2">No Enrolled Courses</h3>
            <p className="text-gray-600 text-sm md:text-base">
              You haven't enrolled in any courses yet. Browse available courses
              below.
            </p>
          </div>
        )}
      </div>

      <div>
        <h2 className="text-xl md:text-2xl font-bold mb-4">
          Available Courses
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {availableCourses.map((course) => (
            <CourseCard key={course.id} course={course} enrolled={false} />
          ))}
        </div>
      </div>
    </div>
  )
}

// Course Card Component
const CourseCard = ({ course, enrolled }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300">
      <div
        className="h-40 bg-cover bg-center"
        style={{ backgroundImage: `url(${course.image})` }}
      ></div>
      <div className="p-4 md:p-5">
        <h3 className="font-semibold text-base md:text-lg mb-2 line-clamp-2">
          {course.title}
        </h3>
        <p className="text-gray-600 text-xs md:text-sm mb-3">
          {course.instructor}
        </p>

        <div className="flex items-center text-xs md:text-sm text-gray-500 mb-4">
          <FontAwesomeIcon icon={faClock} className="mr-1" />
          <span>{course.duration}</span>
        </div>

        {enrolled ? (
          <div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 mb-3">
              <div
                className="bg-primary h-2.5 rounded-full"
                style={{ width: `${course.progress}%` }}
              ></div>
            </div>
            <div className="flex justify-between text-xs md:text-sm">
              <span>Progress: {course.progress}%</span>
              <button className="text-primary hover:underline">Resume</button>
            </div>
          </div>
        ) : (
          <button className="w-full py-2 bg-primary text-white rounded-lg text-xs md:text-sm hover:bg-primary-dark transition-colors">
            Enroll Now
          </button>
        )}
      </div>
    </div>
  )
}

export default Courses
